import {useState} from 'react';
import {
    CCText,
    View,
    AlertModal
} from "../../../../custom-packages/react-native-components-in-react/react-native-components-in-react";
import AppConfig from "../../../../AppConfig";
import PollConstants from "../PollConstants";
import {BorderlessButton} from "../../../../custom-packages/react-button-package/ButtonPackage";
import Styles from "../../../../Styles";
import ChocoFormTS from "../../../../custom-packages/react-chocoforms/typescript/ChocoFormTS";
import ChocoForm from "../../../../custom-packages/react-chocoforms/typescript/models/ChocoForm";
import ChocoControl from "../../../../custom-packages/react-chocoforms/typescript/models/ChocoControl";
import ChocoValidation from "../../../../custom-packages/react-chocoforms/typescript/models/ChocoValidation";


const TQuestionItem = {
    // English
    "enUS": {
        'QUESTION_TEXT': 'Question Text',
        'QUESTION_TYPE': 'Type',
        'OPEN': 'Open',
        'SCORE': 'Score',
        'OPTIONS': 'Options',
        'CANCEL': 'Cancel',
        'REMOVE': 'Remove',
        'OPEN_DESCRIPTION': 'Can be answered with a custom text',
        'SCORE_DESCRIPTION': 'Excellent (5), Good (4), Regular (3), Bad (2), Terrible (1)',
        'OPTIONS_DESCRIPTION': 'Options',
        'REMOVE_DESCRIPTION': 'If you remove this question (@question), all answers to it will also be deleted. It will be deleted when you save the poll.',
        'REQUIRED_QUESTION': 'Required Question',
        'DRAG_AND_DROP': 'Drag and drop to reorder the questions',
    },
    // Spanish
    "esMX": {
        'QUESTION_TEXT': 'Tu Pregunta',
        'QUESTION_TYPE': 'Tipo',
        'OPEN': 'Abierta',
        'SCORE': 'Calificación',
        'OPTIONS': 'Opción Múltiple',
        'CANCEL': 'Cancelar',
        'REMOVE': 'Remover',
        'OPEN_DESCRIPTION': 'Se puede introducir el texto que quiera',
        'SCORE_DESCRIPTION': 'Excelente (5), Bueno (4), Regular (3), Malo (2), Terrible (1)',
        'OPTIONS_DESCRIPTION': 'Opciones',
        'REMOVE_DESCRIPTION': 'Si remueves esta pregunta (@question), todas sus respuestas serán borradas. Se removerá cuando se guarden los cambios de la encuesta.',
        'REQUIRED_QUESTION': 'Requerida',
        'DRAG_AND_DROP': 'Presiona y arrastra para reordenar',
    }
}

const QuestionItem = ({question, onQuestionChange, onRemove}) => {
    const [removeQuestionModalOpen, setRemoveQuestionModalOpen] = useState(false)
    const [removeQuestionModalText, setRemoveQuestionModalText] = useState("")

    const [removed, setRemoved] = useState(false)
    const [mainForm, setMainForm] = useState(new ChocoForm({
        pqu_question: new ChocoControl({
            elementType: 'input',
            elementConfig: {
                placeholder: TQuestionItem[AppConfig.lang].QUESTION_TEXT,
                autoCapitalize: 'words'
            },
            label: TQuestionItem[AppConfig.lang].QUESTION_TEXT,
            value: question.pqu_question,
            className: 'col-lg-6',
            errorMessage: '',
            validation: new ChocoValidation({
                required: true
            }),
        }),
        pqu_type: new ChocoControl({
            elementType: 'select',
            elementConfig: {
                placeholder: TQuestionItem[AppConfig.lang].QUESTION_TYPE,
                autoCapitalize: 'words',
                disabled: !!question.pqu_id,
                isDisabled: !!question.pqu_id
            },
            options: [{
                value: PollConstants.TYPE_OPEN,
                label: TQuestionItem[AppConfig.lang].OPEN
            }, {
                value: PollConstants.TYPE_SCORE,
                label: TQuestionItem[AppConfig.lang].SCORE
            }],
            label: TQuestionItem[AppConfig.lang].QUESTION_TYPE,
            value: question.pqu_type,
            className: 'col-lg-6',
            errorMessage: '',
            validation: new ChocoValidation({
                required: true
            }),
        }),
        pqu_required:  new ChocoControl({
            elementType: 'checkbox',
            elementConfig: {
                placeholder: TQuestionItem[AppConfig.lang].QUESTION_TYPE,
                autoCapitalize: 'words',
            },
            label: TQuestionItem[AppConfig.lang].REQUIRED_QUESTION,
            value: question.pqu_required,
            className: 'col-lg-12',
            errorMessage: '',
            validation: new ChocoValidation({
                required: false
            }),
        })
    }))

    if (removed)
        return null;

    return (
        <View
            className={'card'}
            style={{
                marginBottom: 15,
                overflow: 'initial'
            }}
        >
            <View
                className={'card-body'}
            >
                <CCText
                    className={'alert alert-info'}
                >
                    {TQuestionItem[AppConfig.lang].DRAG_AND_DROP}
                </CCText>
                <ChocoFormTS
                    form={mainForm}
                    onFormChange={(updatedForm) => {
                        setMainForm(updatedForm)

                        if (onQuestionChange) {
                            const newQuestion = {...question};

                            newQuestion.pqu_id = question.pqu_id
                            newQuestion.pqu_question = updatedForm.controls['pqu_question'].value
                            newQuestion.pqu_type = updatedForm.controls['pqu_type'].value
                            newQuestion.pqu_required = updatedForm.controls['pqu_required'].value

                            onQuestionChange(newQuestion);
                        }
                    }}
                />
                <View
                    style={{
                        color: 'gray',
                        marginTop: 15,
                    }}
                >
                    {
                        mainForm.controls['pqu_type'].value === PollConstants.TYPE_OPEN ?
                            <CCText>
                                {TQuestionItem[AppConfig.lang].OPEN_DESCRIPTION}
                            </CCText>
                            :
                            null
                    }
                    {
                        mainForm.controls['pqu_type'].value === PollConstants.TYPE_SCORE ?
                            <CCText>
                                {TQuestionItem[AppConfig.lang].SCORE_DESCRIPTION}
                            </CCText>
                            :
                            null
                    }
                    {
                        mainForm.controls['pqu_type'].value === PollConstants.TYPE_OPTIONS ?
                            <h3>
                                {TQuestionItem[AppConfig.lang].OPTIONS_DESCRIPTION}
                            </h3>
                            :
                            null
                    }
                </View>
                <View
                    style={{flexDirection: 'row', justifyContent: 'flex-end', marginTop: 15}}
                >
                    <BorderlessButton
                        text={TQuestionItem[AppConfig.lang].REMOVE}
                        onPress={() => {
                            if (question.pqu_id) {
                                setRemoveQuestionModalText(TQuestionItem[AppConfig.lang].REMOVE_DESCRIPTION.replace("@question", question.pqu_question))
                                setRemoveQuestionModalOpen(true)
                            } else {
                                setRemoved(true)
                                onRemove()
                            }
                        }}
                        textStyle={{...Styles.redColor}}
                    />
                </View>
            </View>
            <AlertModal
                visible={removeQuestionModalOpen}
                onRequestClose={() => setRemoveQuestionModalOpen(false)}
                title={TQuestionItem[AppConfig.lang].REMOVE}
                text={removeQuestionModalText}
                buttons={[{
                    text: TQuestionItem[AppConfig.lang].CANCEL,
                    onPress: () => setRemoveQuestionModalOpen(false)
                }, {
                    text: TQuestionItem[AppConfig.lang].REMOVE,
                    type: "danger",
                    onPress: () => {
                        setRemoveQuestionModalOpen(false)
                        setRemoved(true)
                        onRemove()
                    }
                }]}
            />
        </View>
    );
};

export default QuestionItem;